"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const configs_1 = require("../configs/configs");
const IContainerInjection_1 = require("auto-widget-framework/src/Container/IContainerInjection");
const Collection_1 = require("../Model/Collection");
const Mixin_1 = require("auto-widget-framework/src/Util/Mixin");
class DealerRepository {
    constructor(config, httpClient, pathUtil, dealerToDataTransformer, errorTransformer) {
        this.config = config;
        this.httpClient = httpClient;
        this.dealerToDataTransformer = dealerToDataTransformer;
        this.errorTransformer = errorTransformer;
        this.pathUtil = pathUtil;
    }
    /**
     * @inheritDoc
     */
    static create(config, container) {
        return new this(config, container.get('http_client'), container.get('path_utils'), container.get('transformer.dealer_to_data'), container.get('transformer.axios_to_error'));
    }
    /**
     * @inheritDoc
     */
    getAll() {
        const url = this.pathUtil.route(configs_1.configs.endpoints.dealer, {});
        return this.httpClient.get(url)
            .catch(err => {
            throw this.errorTransformer.to(err);
        })
            .then(res => {
            return new Collection_1.default(res.data.items.map((dealer) => {
                return this.dealerToDataTransformer.from(dealer);
            }));
        });
    }
}
exports.default = DealerRepository;
Mixin_1.default(DealerRepository, IContainerInjection_1.default);
